import { formatNullableSpend, formatPercent } from "./format-opportunity"

export interface DualSpendDisplay {
  primary: string
  /** Pre-formatted percent string for total creatives (without label). */
  secondaryValue: string | null
  /** Value for bar normalization — total creatives when available. */
  barValue: number | null
  unavailable: boolean
}

/** Resolve primary (per-dataset) and secondary (total creatives) spend display. */
export function getDualSpendDisplay(
  perDataset: number | null,
  totalCreatives: number | null,
  decimals = 1,
): DualSpendDisplay {
  const barValue = totalCreatives ?? perDataset

  // Per-dataset (share within subcategory) is the reliable big number. It shares the
  // total's numerator but has the smaller denominator, so a valid total is always
  // <= per-dataset. When per-dataset is present we always show it as primary, and only
  // surface the "of total creatives" secondary when the total is consistent
  // (<= per-dataset) — this suppresses inflated totals (e.g. > 100%) instead of ever
  // hiding the reliable per-dataset behind them.
  if (perDataset !== null) {
    const secondaryIsConsistent = totalCreatives !== null && totalCreatives <= perDataset
    return {
      primary: formatNullableSpend(perDataset, decimals),
      secondaryValue: secondaryIsConsistent ? formatPercent(totalCreatives, decimals) : null,
      barValue,
      unavailable: false,
    }
  }

  if (totalCreatives !== null) {
    return {
      primary: formatNullableSpend(totalCreatives, decimals),
      secondaryValue: null,
      barValue: totalCreatives,
      unavailable: false,
    }
  }

  return {
    primary: formatNullableSpend(null, decimals),
    secondaryValue: null,
    barValue: null,
    unavailable: true,
  }
}
